import { useCallback } from "react";
import { shallowEqual, useSelector } from "react-redux";

export const useHasPermission = () => {
    const userPermissions = useSelector((state) => state.auth.permissions, shallowEqual);
    return useCallback(
        (permissionName) => Array.isArray(userPermissions) && userPermissions.includes(permissionName),
        [userPermissions],
    );
};
